import styled from 'styled-components';

export const ImagePickerContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.selectedFile ? 'flex-end': 'center'};
  align-items: center;
  color: #183558;
  background: #ffffff;
  border: 1px dashed #00AED9;
  box-sizing: border-box;
  margin: 1rem 0rem;
  height: 120px;
  width: 233px;
  font-weight: bold;
  font-size: 1rem;
  color: #00AED9;
  cursor: pointer;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  :active {
    opacity: 0.5;
  }

`;

export const ReplaceButtonWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  width: 100%;
  justify-content: flex-end;

  button {
    background: white;
    min-width: 70px;
    margin-right: 16px;
    padding: 0 8px;
  }
`;
